import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const apiClient = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json'
  },
  timeout: 30000 // 30 seconds default timeout
});

export const api = {
  // Get app configuration
  getConfig: async () => {
    const response = await apiClient.get('/config');
    return response.data;
  },

  // Get UI texts for a language
  getUiTexts: async (language) => {
    const response = await apiClient.get(`/ui-texts/${language}`);
    return response.data;
  },

  // Get story preview
  getStoryPreview: async (language, protagonistName, protagonistType = 'noi') => {
    const response = await apiClient.post('/story/preview', {
      language,
      protagonist_name: protagonistName,
      protagonist_type: protagonistType
    });
    return response.data;
  },

  // Create lead
  createLead: async (leadData) => {
    const response = await apiClient.post('/leads', {
      language: leadData.language,
      protagonist_name: leadData.protagonistName,
      protagonist_type: leadData.protagonistType || 'noi',
      email: leadData.email,
      privacy_accepted: leadData.privacyAccepted,
      marketing_accepted: leadData.marketingAccepted
    });
    return response.data;
  },

  // Generate PDF
  generatePdf: async (language, protagonistName, leadId) => {
    const response = await apiClient.post('/story/generate-pdf', {
      language,
      protagonist_name: protagonistName,
      lead_id: leadId
    });
    return response.data;
  },

  // Generate printable booklet PDF
  generateBookletPdf: async (protagonistName, protagonistType, email = null) => {
    const payload = {
      protagonist_name: protagonistName,
      protagonist_type: protagonistType
    };
    
    // Add email if provided (for sending PDF via email)
    if (email) {
      payload.email = email;
    }
    
    const response = await apiClient.post('/story/generate-booklet', payload, {
      timeout: 60000 // 60 seconds timeout for PDF generation
    });
    return response.data;
  },

  // Track analytics event
  trackEvent: async (eventType, data = {}) => {
    try {
      await apiClient.post('/analytics/event', {
        event_type: eventType,
        ...data
      });
    } catch (e) {
      console.error('Analytics error:', e);
    }
  }
};

export default api;
